import { ProcessOrderComponent } from '../../../features/operator/order-operations/components/process-order/process-order.component';
import { ViewProcessOrderComponent } from '../../../features/operator/order-operations/pages/view-process-order/view-process-order.component';

export const SIDEBAR_CONFIG = {
  list_order_operations_open_box: ProcessOrderComponent,
  list_completed_order_operations_open_completed_box: ViewProcessOrderComponent,
};
